import { useEffect, useState } from 'react';
import useFetchPropertyIntegrationSettings from 'components/domain/integrationSettings/useFetchPropertyIntegrationSettings';
import { Affiliate } from 'models/Integrations';
import useAppUser from './useAppUser';

const usePaypal = (propertyUid: string) => {
  const { isEmployee } = useAppUser();
  const [usePaypalIntegration, setUsePaypalIntegration] =
    useState<boolean>(false);

  const { data: propertyIntegrations } = useFetchPropertyIntegrationSettings({
    propertyUid,
    enabled: isEmployee && !!propertyUid,
  });

  useEffect(() => {
    setUsePaypalIntegration(false);

    if (!propertyIntegrations) return;

    if (
      propertyIntegrations.filter(
        (propertyIntegration) =>
          propertyIntegration.affiliateEnum === Affiliate.PAYPAL &&
          propertyIntegration.isEnabled,
      ).length > 0
    ) {
      setUsePaypalIntegration(true);
    }
  }, [propertyIntegrations]);

  return usePaypalIntegration;
};

export default usePaypal;
